import { ScoreDailyAverage } from "../../../../types/scores";

const PREVIEW_SCORES: ScoreDailyAverage[][] = [
  [],
  [
    {
      created_at: "2025-03-10",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-11",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-12",
      visibility: 79,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-13",
      visibility: 76,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-14",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-15",
      visibility: 82,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-16",
      visibility: 86,
      sentiment: 75,
      ranking: 3,
    },
  ],
  [],
  [
    {
      created_at: "2025-03-10",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-11",
      visibility: 78,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-12",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-13",
      visibility: 78,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-14",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-15",
      visibility: 82,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-16",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-17",
      visibility: 85,
      sentiment: 75,
      ranking: 3,
    },
  ],
  [
    {
      created_at: "2025-03-10",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-11",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-12",
      visibility: 79,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-13",
      visibility: 81,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-14",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-15",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-16",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
  ],
  [
    {
      created_at: "2025-03-10",
      visibility: 78,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-11",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-12",
      visibility: 75,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-13",
      visibility: 81,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-14",
      visibility: 80,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-15",
      visibility: 75,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-16",
      visibility: 78,
      sentiment: 75,
      ranking: 3,
    },
    {
      created_at: "2025-03-17",
      visibility: 68,
      sentiment: 75,
      ranking: 3,
    },
  ],
  [],
];

const PREVIEW_AI_MODELS = [
  {
    url: "/ai-icons/AI-icon-1.svg",
    name: "OpenAI"
  },
  {
    url: "/ai-icons/AI-icon-2.svg",
    name: "Google"
  },
  {
    url: "/ai-icons/AI-icon-3.svg",
    name: "Meta"
  },
  {
    url: "/ai-icons/AI-icon-4.svg",
    name: "Apple"
  },
  {
    url: "/ai-icons/AI-icon-5.svg",
    name: "Microsoft"
  },
  {
    url: "/ai-icons/AI-icon-6.svg",
    name: "Google"
  },
  {
    url: "/ai-icons/AI-icon-7.svg",
    name: "Meta"
  },
  {
    url: "/ai-icons/AI-icon-8.svg",
    name: "Apple"
  },
  {
    url: "/ai-icons/AI-icon-9.svg",
    name: "Microsoft"
  }
];

export { PREVIEW_SCORES, PREVIEW_AI_MODELS };
